import useSaveConfirmation from './useSaveConfirmation';

function useCancelConfirmation() {
  const confirmation = useSaveConfirmation();

  function requestCancel(event, { shouldConfirm, onCancel, title, message }) {
    event?.preventDefault?.();

    if (!shouldConfirm()) {
      onCancel();
      return;
    }

    confirmation.requestConfirmation(event, onCancel, {
      title: title || 'Discard changes?',
      message: message || 'You have unsaved inputs. Please confirm if you want to discard them.',
      confirmLabel: 'Discard',
      cancelLabel: 'Keep Editing',
    });
  }

  return {
    requestCancel,
    modalProps: confirmation.modalProps,
  };
}

export default useCancelConfirmation;
